import React from "react";

export default function ConversationHeader({ typingUser }) {
  return (
    <div className="p-4 bg-white border-b flex items-center justify-between">
      <div>
        <h2 className="text-lg font-semibold">Conversation</h2>
        {typingUser && (
          <p className="text-sm text-blue-600">L’utilisateur écrit…</p>
        )}
      </div>
    </div>
  );
}
